// Libs
import _reduce from 'lodash/reduce'

// Controller
import controller from 'fc-ctrl-assets'

// Constants
import { BRANCH } from './constants'
import { PROP_ASSET_ID, PROP_SHAPE } from 'fc-model-assets'

// Utils
import traverse from 'fc-utils/traverse'

const reducerMap = {
  ...controller.reducers,
  [controller.actionTypes.receive()]: (state, {data}) => {
    return {
      ...state,
      [BRANCH]: {
        ...state[BRANCH],
        ..._reduce(data, function (acc, asset) {
          acc[asset[PROP_ASSET_ID]] = {
            ...asset,
            [PROP_SHAPE]: asset[PROP_SHAPE]
              ? asset[PROP_SHAPE]
              : (asset[PROP_SHAPE] !== false) ? traverse([BRANCH, asset[PROP_ASSET_ID], PROP_SHAPE])(state) : null,
          }

          return acc
        }, {}),
      },
    }
  },
}

export default reducerMap
